"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactIntl = require("react-intl");

var _Button = _interopRequireDefault(require("@react/react-spectrum/Button"));

var _EmptyState = _interopRequireDefault(require("./EmptyState"));

var _svgs = require("../../lib/svgs");

var _comments = require("../../actions/comments");

var _reducers = require("../../reducers");

var _AppContext = _interopRequireDefault(require("../../context/AppContext"));

var _ErrorEmptyState = _interopRequireDefault(require("./ErrorEmptyState.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/***************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ***************************************************************************/
var ErrorEmptyState = function ErrorEmptyState() {
  var dispatch = (0, _reducers.useDispatch)();

  var _useContext = (0, _react.useContext)(_AppContext.default),
      setAsset = _useContext.asset.setAsset,
      _useContext$assetData = _useContext.assetData,
      assetData = _useContext$assetData === void 0 ? {} : _useContext$assetData,
      _useContext$imsData = _useContext.imsData,
      imsData = _useContext$imsData === void 0 ? {} : _useContext$imsData,
      isOffline = _useContext.isOffline,
      cacheComments = _useContext.cacheComments,
      imageCapture = _useContext.imageCapture,
      globalCommentsToggle = _useContext.globalCommentsToggle,
      globalComments = _useContext.globalComments,
      globalCommentsUnmapped = _useContext.globalCommentsUnmapped;

  var handleRetry = (0, _react.useCallback)(function () {
    dispatch((0, _comments.commentsGet)(assetData, isOffline, cacheComments, imsData.id, imageCapture, globalComments, globalCommentsToggle.isActive, globalCommentsUnmapped)).then(function (respAsset) {
      setAsset(respAsset);
    }).catch(function () {
      setAsset(undefined);
    });
  }, [dispatch, assetData, isOffline, cacheComments, imsData.id, imageCapture, globalComments, globalCommentsToggle.isActive, globalCommentsUnmapped, setAsset]);
  return /*#__PURE__*/_react.default.createElement(_EmptyState.default, {
    className: _ErrorEmptyState.default.component
  }, /*#__PURE__*/_react.default.createElement(_EmptyState.default.Illustration, null, _svgs.ErrorIllustration), /*#__PURE__*/_react.default.createElement(_EmptyState.default.Title, null, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    id: "comments.list.error"
  })), /*#__PURE__*/_react.default.createElement(_Button.default, {
    onClick: handleRetry,
    "data-testid": "comments-error-state-primary"
  }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    id: "comments.list.error-retry"
  })));
};

var _default = ErrorEmptyState;
exports.default = _default;